// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { OrderChangeRequestLineStateModel } from "@store/Framework/Types/ApiModels";
import { ProductLineStatusType } from "@store/Library/Components/ProductLine/ProductLineStatusOverlay";
import { orderV2Props } from "@store/Themes/common/props/orderV2";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { FC } from "react";
import { css } from "styled-components";

export interface OrderChangeRequestLineInformationProps {
    lineState: OrderChangeRequestLineStateModel;
    status?: ProductLineStatusType;
}

export interface OrderChangeRequestLineInformationStyles {
    wrapper?: InjectableCss;
    reasonInfoWrapper?: InjectableCss;
    notesInfoWrapper?: InjectableCss;
    quantityInfoWrapper?: InjectableCss;
    infoLabel?: TypographyPresentationProps;
    infoValue?: TypographyPresentationProps;
}

const OrderChangeRequestLineInformationStyles: OrderChangeRequestLineInformationStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-wrap: wrap;
            gap: ${pxToRem(16, 24)};
        `,
    },
    reasonInfoWrapper: mergeProps(orderV2Props.infoWrapper, {
        css: css`
            flex-grow: 1;
            flex-basis: ${pxToRem(320)};
        `,
    }),
    notesInfoWrapper: mergeProps(orderV2Props.infoWrapper, {
        css: css`
            flex-grow: 999999;
            flex-basis: ${pxToRem(320)};
        `,
    }),
    quantityInfoWrapper: mergeProps(orderV2Props.infoWrapper, {
        css: css`
            flex-basis: 0;
            min-width: ${pxToRem(100)};
        `,
    }),
    infoLabel: orderV2Props.infoLabel,
    infoValue: orderV2Props.infoValue,
};

const styles = OrderChangeRequestLineInformationStyles;

const OrderChangeRequestLineInformation: FC<OrderChangeRequestLineInformationProps> = ({ lineState, status }) => {
    if (!lineState) {
        return null;
    }

    const emptyValue = status ? translate("N/A") : "—";

    return (
        <StyledWrapper {...styles.wrapper}>
            <StyledWrapper {...styles.reasonInfoWrapper}>
                <StyledWrapper {...styles.infoLabel}>{translate("Change Request Reason")}</StyledWrapper>
                <StyledWrapper {...styles.infoValue} data-test-selector="orderChangeRequestLineInformation_reason">
                    {lineState.changeReason ? translate(`${lineState.changeReason}`) : emptyValue}
                </StyledWrapper>
            </StyledWrapper>
            <StyledWrapper {...styles.notesInfoWrapper}>
                <StyledWrapper {...styles.infoLabel}>{translate("Change Request Note")}</StyledWrapper>
                <StyledWrapper {...styles.infoValue} data-test-selector="orderChangeRequestLineInformation_notes">
                    {lineState.changeNotes || emptyValue}
                </StyledWrapper>
            </StyledWrapper>
            <StyledWrapper {...styles.quantityInfoWrapper}>
                <StyledWrapper {...styles.infoLabel}>{translate("New QTY")}</StyledWrapper>
                <StyledWrapper {...styles.infoValue} data-test-selector="orderChangeRequestLineInformation_quantity">
                    {lineState.newQuantity || emptyValue}
                </StyledWrapper>
            </StyledWrapper>
        </StyledWrapper>
    );
};

export default OrderChangeRequestLineInformation;
